import React, { Component } from 'react';
import OptyDialog from './OptyDialog';
import TextField from 'material-ui/TextField';
import { formatNumField } from "./format";
import api from './api';

class ExerciseWidget extends Component {

  state = {};

  run(optionAddress) {
    this.setState({ option: {}, amount: "" }, () => this.dialog.run());
    this.unsub = api.option(optionAddress).subscribe(option => this.setState({ option }));
  }

  exercise() {
    this.state.option.exercise(+this.state.amount);
  }

  unsub() {
    if (this.unsub) this.unsub();
  }

  render() {
    const { option, amount } = this.state;
    const { symbol, balance } = (option || {});
    const label = symbol || 'options';
    const helper = balance ? "Maximum: " + balance.toString() : null

    return (
      <OptyDialog ref={dialog=>{this.dialog = dialog}} title={"Exercise " + label} onOK={()=>this.exercise()} onClose={()=>this.unsub()}>
      <div>
        <TextField
          style={{width:'100%'}}
          label={"How many options to exercise?"}
          value={amount}
          onChange={(event)=>this.setState({amount: formatNumField(event.target.value)})}
          helperText={helper}
        />
        </div>
      </OptyDialog>
    )
  }
}

export default ExerciseWidget;


// WEBPACK FOOTER //
// ./src/ExerciseWidget.js